module.exports = __webpack_public_path__ + "static/media/muiz.7eb6d6e0.jpg";